import { motion } from 'motion/react';

export type CountdownChipProps = {
  /** Pre-formatted label. Empty string hides the chip. */
  label: string;
  eyebrow?: string;
  /** Pass null/undefined to disable urgency styling. */
  remainingSeconds?: number | null;
  /** Default 10s. */
  urgentBelow?: number;
  className?: string;
};

export const CountdownChip = ({
  label,
  eyebrow,
  remainingSeconds,
  urgentBelow = 10,
  className,
}: CountdownChipProps) => {
  if (!label) return null;
  const urgent = typeof remainingSeconds === 'number' && remainingSeconds <= urgentBelow;

  return (
    <motion.div
      animate={urgent ? { scale: [1, 1.06, 1] } : { scale: 1 }}
      transition={
        urgent
          ? { duration: 0.9, repeat: Number.POSITIVE_INFINITY, ease: 'easeInOut' }
          : { duration: 0.3 }
      }
      className={[
        'inline-flex flex-col items-center rounded-md border-[2.5px] border-ink px-3 py-1.5 shadow-[3px_3px_0_var(--color-ink)]',
        urgent ? 'bg-und text-white' : 'bg-cream text-ink',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {eyebrow && (
        <span className="font-display font-extrabold text-[8.5px] uppercase tracking-[0.2em] opacity-70">
          {eyebrow}
        </span>
      )}
      <span className="font-display font-extrabold text-base tabular-nums">{label}</span>
    </motion.div>
  );
};
